import { defineMessages } from 'react-intl';

/** The copy of the release page shell: the head, the tabs and the not-found state (Releases v2, design b, e2). */
export const releaseMessages = defineMessages({
  unreleased: { id: 'app.sml.releases.unreleased', defaultMessage: 'unreleased' },
  outToday: { id: 'app.sml.releases.when.today', defaultMessage: 'Out today' },
  outInDays: {
    id: 'app.sml.releases.when.inDays',
    defaultMessage: '{days, plural, one {Out tomorrow} other {Out in # days}}',
  },
  outOn: { id: 'app.sml.releases.when.on', defaultMessage: 'Out {date}' },
  noDate: { id: 'app.sml.releases.when.noDate', defaultMessage: 'No release date' },
  presaveLive: { id: 'app.sml.releases.head.presaveLive', defaultMessage: 'Pre-save live' },
  presaveEnded: { id: 'app.sml.releases.head.presaveEnded', defaultMessage: 'Pre-save ended' },
  smartLink: { id: 'app.sml.releases.head.smartLink', defaultMessage: 'Smartlink {address}' },
  smartLinkLive: { id: 'app.sml.releases.head.smartLinkLive', defaultMessage: 'SmartLink live' },
  noSmartLink: { id: 'app.sml.releases.head.noSmartLink', defaultMessage: 'No SmartLink' },
  presaveNeedsPlan: {
    id: 'app.sml.releases.head.presaveNeedsPlan',
    defaultMessage: 'Pre-save pages come with Plus and Pro.',
  },
  presaveSeePlans: { id: 'app.sml.releases.head.presaveSeePlans', defaultMessage: 'See plans' },
  theme: { id: 'app.sml.releases.head.theme', defaultMessage: 'Theme: {theme}' },
  daysToGo: {
    id: 'app.sml.releases.head.daysToGo',
    defaultMessage: '{days, plural, one {day to go} other {days to go}}',
  },
  daysOut: {
    id: 'app.sml.releases.head.daysOut',
    defaultMessage: '{days, plural, one {day out} other {days out}}',
  },
  countdown: {
    id: 'app.sml.releases.head.countdown',
    defaultMessage: '{days, plural, one {day to release} other {days to release}}',
  },
  openStudio: { id: 'app.sml.releases.head.openStudio', defaultMessage: 'Open Studio' },
  downloadAll: { id: 'app.sml.releases.head.downloadAll', defaultMessage: 'Download all (.zip)' },
  downloadZip: { id: 'app.sml.releases.head.downloadZip', defaultMessage: 'Download the zip' },
  tabs: { id: 'app.sml.releases.tabList', defaultMessage: 'Release' },
  tabOverview: { id: 'app.sml.releases.tab.overview', defaultMessage: 'Overview' },
  tabKit: { id: 'app.sml.releases.tab.kit', defaultMessage: 'Kit' },
  tabPosts: { id: 'app.sml.releases.tab.posts', defaultMessage: 'Posts' },
  tabReleasePlan: { id: 'app.sml.releases.tab.releasePlan', defaultMessage: 'Release plan' },
  tabCampaign: { id: 'app.sml.releases.tab.campaign', defaultMessage: 'Auto campaign' },
  workingBanner: {
    id: 'app.sml.releases.workingBanner',
    defaultMessage:
      '{count, plural, one {# asset is working} other {# assets are working}} for {title}. They show up under "Just made" when they are ready. You can leave this page.',
  },
  seeWork: { id: 'app.sml.releases.seeWork', defaultMessage: 'See the work' },
  notFoundTitle: { id: 'app.sml.releases.notFound.title', defaultMessage: 'This song is not in your catalog.' },
  notFoundBody: {
    id: 'app.sml.releases.notFound.body',
    defaultMessage: 'It was removed, or it belongs to another artist or workspace.',
  },
  backToReleases: { id: 'app.sml.releases.back', defaultMessage: 'Back to Releases' },
});
